// src/lib/api.js or src/axiosConfig.js
import axios from 'axios';

const API = axios.create({
  baseURL: 'https://back.varankal.com',
  withCredentials: true,
});

// Interceptor for 401 and logout message global handling
API.interceptors.response.use(
  response => response,
  error => {
    const isUnauthorized = error.response?.status === 401;
    const isLoggedOut = error.response?.data?.message?.toLowerCase().includes('logged out');

    if (isUnauthorized || isLoggedOut) {
      alert(error.response?.data?.message || 'You have been logged out. Please log in again.');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('profileCreated');
      window.location.href = '/';
    }

    return Promise.reject(error);
  }
);

export default API;
